<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <h4 style="color: #000; text-align: left" class="custom-user-name">
              Select subjects that you want to focus on
            </h4>
            <br />
            <form class="ml-3 mr-3">
              <label
                v-for="item in students.focusSubject"
                :key="item.Id"
                :index="item.Id"
                class="ml-3 sub-title-card text-black"
                >{{ item.subjectName }},</label
              >
              <!-- <img
                class="float-right"
                src="../../assets/img/icon/iconContainer.svg"
              /> -->
            </form>
            <div class="ml-3 mr-3">
              <v-select
              v-model="SelectedSubject"
              horizontal
              :options="subject"
              label="subjectName"
              placeholder="Select Subject"
            />
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton class="btn-select-blue mt-5" @click="UpdateSubject">Save</CButton>
    </div>
    <div class="header-top">Change Exam</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  data: function () {
    return {
      // SubjectId: this.$route.query.subjectId,
      // SubjectName: this.$route.query.shortSubjectName,
      students: [],
      user: {},
      studentProfileAuthorize: "",
      childs: [],
      parent: [],
      subject: [],
      FilterSubject: [],
      SelectedSubject: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetParentDetail(this.user.id);
            this.GetProfileStudentsByStudentId();
            this.GetSubject();
          }
        });
    },
    GetSubject() {
      this.$API
        .get(this.$SubjectListAuthorize, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subject = response.data;
            this.FilterSubject = this.subject;
          }
        });
    },
    GetProfileStudentsByStudentId() {
      this.$API
        .get(
          this.$GetStudentDetailByStudentId +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
          }
        });
    },
    GetParentDetail() {
      this.$API
        .get(this.$GetParentDetailByUserId + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parent = response.data;
          }
        });
    },
    GoBack() {
      this.$router.back();
    },
    UpdateSubject: function () {
      const formData = new FormData();
      formData.append("ManualStudentId", this.students.id);
      formData.append("SubjectId", this.SelectedSubject.id);

      return this.$API
        .post(this.$UpdateStudentFocusSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="radio"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
</style>